export const visit = (vm, at) => {
at({ "en": { "conversations-inbox-message-history": { "workflow-generated-user-message": { "source-workflow": "Source workflow:" } } } });
};